import { Authorization, Token, UserInfo } from '@/constants/authorization';
import { getSearchValue } from './common-util';
const KeySet = [Authorization, Token, UserInfo];
const SESSION_COOKIE_KEYS = [
  'langflow_proxy_token',
  'leafflow_context_token',
  'langflow_access_token',
  'token',
  'access_token',
  'refresh_token',
];

const storage = {
  getAuthorization: () => {
    return localStorage.getItem(Authorization);
  },
  getToken: () => {
    return localStorage.getItem(Token);
  },
  getUserInfo: () => {
    return localStorage.getItem(UserInfo);
  },
  getUserInfoObject: () => {
    return JSON.parse(localStorage.getItem('userInfo') || '');
  },
  setAuthorization: (value: string) => {
    localStorage.setItem(Authorization, value);
  },
  setToken: (value: string) => {
    localStorage.setItem(Token, value);
  },
  setUserInfo: (value: string | Record<string, unknown>) => {
    let valueStr = typeof value !== 'string' ? JSON.stringify(value) : value;
    localStorage.setItem(UserInfo, valueStr);
  },
  setItems: (pairs: Record<string, string>) => {
    Object.entries(pairs).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  },
  removeAuthorization: () => {
    localStorage.removeItem(Authorization);
  },
  removeAll: () => {
    KeySet.forEach((x) => {
      localStorage.removeItem(x);
    });
  },
  setLanguage: (lng: string) => {
    localStorage.setItem('lng', lng);
  },
  getLanguage: (): string => {
    return localStorage.getItem('lng') as string;
  },
};

export const getAuthorization = () => {
  const auth = getSearchValue('auth');
  const authorization = auth
    ? 'Bearer ' + auth
    : storage.getAuthorization() || '';

  return authorization;
};

export default storage;

export function clearBrowserSession() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.clear();
  } catch (error) {
    // ignore
  }

  try {
    sessionStorage.clear();
  } catch (error) {
    // ignore
  }

  if (typeof document === 'undefined') {
    return;
  }

  const cookieNames = document.cookie
    .split(';')
    .map((item) => item.split('=')[0]?.trim())
    .filter(Boolean) as string[];

  const hostnameParts = window.location.hostname.split('.');
  const allCookieNames = new Set([...cookieNames, ...SESSION_COOKIE_KEYS]);
  const expiry = 'Thu, 01 Jan 1970 00:00:00 GMT';

  allCookieNames.forEach((cookieName) => {
    document.cookie = `${cookieName}=; expires=${expiry}; path=/`;
    document.cookie = `${cookieName}=; max-age=0; path=/`;

    for (let i = 0; i < hostnameParts.length - 1; i += 1) {
      const domain = `.${hostnameParts.slice(i).join('.')}`;
      document.cookie = `${cookieName}=; expires=${expiry}; path=/; domain=${domain}`;
      document.cookie = `${cookieName}=; max-age=0; path=/; domain=${domain}`;
    }
  });
}

export function handleBadGatewayAndRedirect(error: any): boolean {
  const status =
    Number(error?.response?.status) ||
    Number(error?.response?.statusCode) ||
    Number(error?.status) ||
    0;
  const url = String(
    error?.response?.url || error?.request?.responseURL || error?.request?.url || '',
  );
  const isTenantInfoRequest =
    url.includes('/user/tenant_info') || url.includes('/v1/user/tenant_info');

  if (
    status === 502 &&
    isTenantInfoRequest &&
    typeof window !== 'undefined' &&
    !window.location.pathname.startsWith('/login')
  ) {
    clearBrowserSession();
    redirectToLogin();
    return true;
  }
  return false;
}

// Will not jump to the login page
export function redirectToLogin() {
  window.location.href = location.origin + `/login`;
}
